/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GroupLocations,
  GroupUserStatusesOnAzure,
  LocationQueryByTimeRequest,
  UserLocationOnAzure,
} from '../models/index';
import {
    GroupLocationsFromJSON,
    GroupLocationsToJSON,
    GroupUserStatusesOnAzureFromJSON,
    GroupUserStatusesOnAzureToJSON,
    LocationQueryByTimeRequestFromJSON,
    LocationQueryByTimeRequestToJSON,
    UserLocationOnAzureFromJSON,
    UserLocationOnAzureToJSON,
} from '../models/index';

export interface ApiUserStatusGroupsGetRequest {
    orgCode?: string;
}

export interface ApiUserStatusGroupsGroupNameGetRequest {
    groupName: string;
}

export interface ApiUserStatusUserLocationsTimerangePostRequest {
    locationQueryByTimeRequest?: LocationQueryByTimeRequest;
}

/**
 * 
 */
export class UserStatusApi extends runtime.BaseAPI {

    /**
     */
    async apiUserStatusGroupLocationsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserLocationOnAzure>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/UserStatus/group/locations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserLocationOnAzureFromJSON));
    }

    /**
     */
    async apiUserStatusGroupLocationsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserLocationOnAzure>> {
        const response = await this.apiUserStatusGroupLocationsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiUserStatusGroupsGetRaw(requestParameters: ApiUserStatusGroupsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GroupUserStatusesOnAzure>>> {
        const queryParameters: any = {};

        if (requestParameters['orgCode'] != null) {
            queryParameters['orgCode'] = requestParameters['orgCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/UserStatus/groups`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GroupUserStatusesOnAzureFromJSON));
    }

    /**
     */
    async apiUserStatusGroupsGet(requestParameters: ApiUserStatusGroupsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GroupUserStatusesOnAzure>> {
        const response = await this.apiUserStatusGroupsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiUserStatusGroupsGroupNameGetRaw(requestParameters: ApiUserStatusGroupsGroupNameGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupUserStatusesOnAzure>> {
        if (requestParameters['groupName'] == null) {
            throw new runtime.RequiredError(
                'groupName',
                'Required parameter "groupName" was null or undefined when calling apiUserStatusGroupsGroupNameGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/UserStatus/groups/{groupName}`;
        urlPath = urlPath.replace(`{${"groupName"}}`, encodeURIComponent(String(requestParameters['groupName'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupUserStatusesOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiUserStatusGroupsGroupNameGet(requestParameters: ApiUserStatusGroupsGroupNameGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupUserStatusesOnAzure> {
        const response = await this.apiUserStatusGroupsGroupNameGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiUserStatusUserLocationsTimerangePostRaw(requestParameters: ApiUserStatusUserLocationsTimerangePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: Array<UserLocationOnAzure>; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/UserStatus/user/locations/timerange`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LocationQueryByTimeRequestToJSON(requestParameters['locationQueryByTimeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiUserStatusUserLocationsTimerangePost(requestParameters: ApiUserStatusUserLocationsTimerangePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: Array<UserLocationOnAzure>; }> {
        const response = await this.apiUserStatusUserLocationsTimerangePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiUserStatusUserMobileLocationsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GroupLocations>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/UserStatus/user/mobile/locations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GroupLocationsFromJSON));
    }

    /**
     */
    async apiUserStatusUserMobileLocationsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GroupLocations>> {
        const response = await this.apiUserStatusUserMobileLocationsGetRaw(initOverrides);
        return await response.value();
    }

}
